import { useState, useEffect } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import { useDispatch } from "react-redux";
import CompanyDashboardWrapper from "components/lib/Shared/CompanyDashboardWrapper";
import { getTransactionUnderReviewAsync } from "state/slices/transaction";
import { getCompany } from "state/slices/company";
import { useSelector } from "react-redux";
import BRSFormsUploads from "components/TransactionReviewTab/BRSFormsUpload";

const TransactionBRSFormsSignature = () => {
  const { trxId, companyId } = useParams();
  const dispatch = useDispatch();
  const urlString = window.location.search; // Gets the query string part of the URL
  const urlParams = new URLSearchParams(urlString);
  const isViewMode = urlParams.get("isViewMode");
  const { transactionUnderReview, getTransactionUnderReview } = useSelector(
    (state) => state.transactionSlice
  );

  useEffect(() => {
    dispatch(
      getTransactionUnderReviewAsync({
        trxId,
      })
    );
    dispatch(
      getCompany({
        companyId,
        queryparams: {
          isDashboard: true,
        },
      })
    );
  }, [trxId]);

  if (transactionUnderReview?.items?.transactions?.length > 0) {
    return (
      <div>
        <CompanyDashboardWrapper>
          <BRSFormsUploads isRegistrar={true} />
        </CompanyDashboardWrapper>
      </div>
    );
  }
  if (getTransactionUnderReview.status === "loading") {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-gray-500">Loading...</p>
      </div>
    );
  }
  return (
    <div className="flex items-center justify-center h-full">
      <p className="text-gray-500">No transaction under review found.</p>
    </div>
  );
};

export default TransactionBRSFormsSignature;
